import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ShieldIcon, ArrowRightIcon } from 'lucide-react';
export const AlloyGatorSection = () => {
  return <section className="py-24 bg-gradient-to-b from-[#121212] to-[#0a0a0a] relative overflow-hidden" data-id="element-60">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 z-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre-v2.png')]" data-id="element-61"></div>
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#D6281F]/5 to-transparent" data-id="element-62"></div>
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-[#D6281F]/5 to-transparent rounded-full blur-3xl" data-id="element-63"></div>
      <div className="max-w-screen-xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-64">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-65">
          {/* Image Section with aspect ratio container */}
          <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-66">
            <div className="relative" data-id="element-67">
              <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-68"></div>
              <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-69">
                {/* Aspect ratio container */}
                <div className="relative w-full" style={{
                paddingBottom: '75%'
              }} data-id="element-70">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d9Rkg47SKWSVtxvpKhbWvX/1_%281%29.jpg" alt="AlloyGator wielkastbeschermer geïnstalleerd op een zwarte velg" className="absolute inset-0 w-full h-full object-cover" decoding="async" data-id="element-71" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-72"></div>
              </div>
            </div>
          </div>
          {/* Content Section */}
          <div className="w-full lg:w-1/2 order-1 lg:order-2" data-id="element-73">
            <div className="flex items-center mb-6" data-id="element-74">
              <div className="bg-[#D6281F]/20 p-2 rounded-full mr-4" data-id="element-75">
                <ShieldIcon size={28} className="text-[#D6281F]" data-id="element-76" />
              </div>
              <div className="h-px flex-grow bg-gradient-to-r from-[#D6281F] to-transparent" data-id="element-77"></div>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-78">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F]" data-id="element-79">
                AlloyGator
              </span>
            </h2>
            <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-80">
              De ultieme bescherming voor uw voertuig! Onze hoogwaardige
              wielkastbeschermers zijn gemaakt van een duurzaam en flexibel
              materiaal dat uw auto beschermt tegen steenslag, roest en andere
              beschadigingen. Dankzij de eenvoudige installatie en het strakke
              design is AlloyGator de perfecte keuze voor elke autoliefhebber.
            </p>
            <div className="space-y-4 mb-8" data-id="element-81">
              <div className="flex items-center" data-id="element-82">
                <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-83"></div>
                <span className="text-white/90" data-id="element-84">
                  Beschermt tegen stoepschade en steenslag
                </span>
              </div>
              <div className="flex items-center" data-id="element-85">
                <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-86"></div>
                <span className="text-white/90" data-id="element-87">
                  Verkrijgbaar in verschillende kleuren
                </span>
              </div>
              <div className="flex items-center" data-id="element-88">
                <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-89"></div>
                <span className="text-white/90" data-id="element-90">
                  Professionele installatie door BKCustoms
                </span>
              </div>
            </div>
            <Link to="/diensten/alloygator" className="inline-flex items-center bg-white/5 hover:bg-white/10 border border-white/20 text-white px-6 py-3 rounded-md transition-all duration-300 group" data-id="element-91">
              <span className="mr-2" data-id="element-92">Ontdek meer over AlloyGator</span>
              <ArrowRightIcon size={16} className="transition-transform duration-300 group-hover:translate-x-1" data-id="element-93" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
};